import React, { Fragment, useState, useEffect } from "react"
import DatePicker from "react-datepicker"
import { Link } from "react-router-dom"
import Select from "react-select"
import { Col, Collapse, Label, Row, Form } from "reactstrap"
import moment from "moment"
import { uniqBy } from "lodash"
import { customStylesSelect } from "common/data/settings"
// Define a default UI for filtering

const FilterLayout = props => {
  const {
    timeSheetLists,
    handleSubmit,
    selectedMainCategory,
    MainCategory,
    SubCategory,
    selectedSubcategory,
    companySetting,
  } = props
  const clientList = [
    {
      label: "ALL",
      value: "11",
    },
  ]

  const projectsList = [
    {
      label: "ALL",
      value: "11",
    },
  ]

  const [isadvancefilter, setisadvancefilter] = useState(false)
  const [selectedClient, setSelectedClient] = useState(clientList[0])
  const [selectedProject, setSelectedProject] = useState(projectsList[0])


  // Sorting the Dropdown values
  function SortArray(x, y) {
    if (x.name < y.name) {
      return -1
    }
    if (x.name > y.name) {
      return 1
    }
    return 0
  }

  const maincategory = MainCategory?.sort(SortArray)
  const subCategory = SubCategory?.sort(SortArray)
  const authUser = JSON.parse(localStorage.getItem("authUser"))
  const accessgroupname = authUser?.data?.accessgroupname

  const startDateChange = date => {
    props.setStartDate(date)
    //  props.sethideDateColumn(moment(date).format("YYYY/MM/DD") === moment(props.endDate).format("YYYY/MM/DD") ? true : false )
  }
  const endDateChange = date => {
    props.setEndDate(date)
  }

  const toggleAdvanceFilter = () => {
    setisadvancefilter(!isadvancefilter)
  }

  const filterDate = () => {
    props.sethideDateColumn(
      moment(props.startDate).format("YYYY/MM/DD") ===
        moment(props.endDate).format("YYYY/MM/DD")
        ? true
        : false
    )
    props.onHandleFilterBtnClicked()
  }

  const [clients, setClients] = useState([])
  const [projects, setProjects] = useState([])

  useEffect(() => {
    const jsonData = props.timeSheetLists
    const jsonDataS =
      jsonData.length > 0
        ? jsonData
            .map(el => el.projectTimeSheet)
            .reduce((acc, arr) => [...acc, ...arr])
        : []
    const uniqueDataClient = uniqBy(jsonDataS, "clientName")
    const uniqueDataProject = uniqBy(jsonDataS, "projectName")
    setClients(uniqueDataClient)
    setProjects(uniqueDataProject)
  }, [timeSheetLists])

  useEffect(() => {
    const jsonData = props.timeSheetLists
    const uniqueData = Array.from(
      new Set(jsonData?.map(item => item.project))
    ).map(project => {
      return jsonData?.find(item => item.project === project)
    })
    setProjects(uniqueData)
  }, [])

  const projectFilter = value => {
    props.handleProjectFilter(value)
    setSelectedProject(value)
  }

  const clientFilter = value => {
    props.handleClientFilter(value)
    setSelectedClient(value)
  }
  
  return (
    <Fragment>
      <Row className="mb-2">
        <Col sm="12" className="d-flex justify-content-end mobile_filter">
          <Form onSubmit={handleSubmit}>
            <div className="text-sm-end">
              <div className=" d-flex text-sm-end mobile_responsive_filter">
                <div className="mx-2">
                  <DatePicker
                    dateFormat="yyyy-MM-dd"
                    selected={props.startDate}
                    onChange={startDateChange}
                    className="form-control mb-0 date-icon-back"
                    placeholderText="Select date"
                    maxDate={new Date()}
                  />
                </div>

                <div className="mx-2">
                  <DatePicker
                    dateFormat="yyyy-MM-dd"
                    selected={props.endDate}
                    onChange={endDateChange}
                    className="form-control mb-0 date-icon-back"
                    placeholderText="Select date"
                    minDate={new Date(props.startDate)}
                    // maxDate={new Date()}
                    maxDate={new Date()}

                  />
                </div>
                <div className="mx-2">
                  <button
                    className="btn btn-primary"
                    // onClick={filterDate}
                    type="submit"
                    onClick={handleSubmit}
                  >
                    <i className="bx bx-filter-alt align-middle"></i> Filter
                  </button>
                </div>

                <div className="mx-2 toggleAdvanceFilter">
                  <button
                    onClick={toggleAdvanceFilter}
                    className="btn btn-primary"
                  >
                    <i className="bx bx-filter-alt align-middle"></i> Advance
                  </button>
                </div>
              </div>
            </div>
          </Form>
        </Col>

        <Col sm="12" className="mt-2 mb-2">
          <Collapse isOpen={isadvancefilter}>
            <Row>
              <Col md="12">
                <Row>
                  <Col md="4">
                    <div>
                      <Label htmlFor="formrow-state-Input">
                        {companySetting?.MainCategory}
                      </Label>
                      <Select
                        isClearable
                        className="mb-2"
                        value={selectedMainCategory}
                        onChange={value => clientFilter(value)}
                        placeholder="ALL"
                        options={[
                          { id: 0, name: "ALL", value: 0, label: "ALL" },
                        ].concat(
                          maincategory?.map(el => ({
                            ...el,
                            label: el.name,
                            value: el.name,
                          }))
                        )}
                        classNamePrefix="select2-selection"
                        styles={customStylesSelect}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div>
                      <Label htmlFor="formrow-state-Input">
                        {companySetting?.SubCategory}
                      </Label>
                      <Select
                        isClearable
                        className="mb-2"
                        value={selectedSubcategory}
                        onChange={value => projectFilter(value)}
                        placeholder="ALL"
                        options={[
                          { id: 0, name: "ALL", value: 0, label: "ALL" },
                        ].concat(
                          SubCategory?.map(el => ({
                            ...el,
                            label: el.name,
                            value: el.name,
                          }))
                        )}
                        classNamePrefix="select2-selection"
                        styles={customStylesSelect}
                      />
                    </div>
                  </Col>

                  <Col md="4">
                    <div>
                      <Label htmlFor="formrow-state-Input">Hours</Label>
                      <Select
                        isClearable
                        isMulti={true}
                        className="mb-2"
                        value={props.selectedHours}
                        onChange={value => props.handleHoursFilter(value)}
                        options={props.hoursList?.map(el => ({
                          ...el,
                          label: el.label,
                          value: el.value,
                        }))}
                        classNamePrefix="select2-selection"
                        styles={customStylesSelect}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Collapse>
        </Col>
      </Row>
    </Fragment>
  )
}

export default FilterLayout
